
import React, { useState } from "react";
import GroupsIcon from "@mui/icons-material/Groups";
import ModelTrainingIcon from '@mui/icons-material/ModelTraining';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import WorkIcon from '@mui/icons-material/Work';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';

const achievements = [
  {
    id: "partner-universities",
    icon: AccountBalanceIcon,
    count: 29,
    label: "Partner Universities",
    tooltip: "We collaborate with 29 universities nationwide to expand our reach.",
    color: "red",
  },
  {
    id: "reached-candidates",
    icon: GroupsIcon,
    count: 269438,
    label: "Reached Candidates",
    tooltip: "We reached more than 269,438 candidates through our programs.",
    //color: "orange",
  },
  {
    id: "trainers",
    icon: PersonAddIcon,
    count: 833,
    label: "Training Of Trainers",
    tooltip: "Over 833 trainers have been trained to enhance capacity building.",
    color: "blue",
  },
  {
    id: "trainees",
    icon: ModelTrainingIcon,
    count: 127083,
    label: "Trainees",
    tooltip: "More than 127,083 trainees went through our various career readiness trainings.",
    color: "green",
  },
  {
    id: "placements",
    icon: WorkIcon,
    count: 109616,
    label: "Placements",
    tooltip: "Over 109,616 candidates successfully landed a job after passing through our interventions.",
    color: "purple",
  },
];

export default function AchievementSection() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  const [hoveredId, setHoveredId] = useState(null);


  const bgHoverClasses = {
    red: "hover:bg-red-100",
    orange: "hover:bg-orange-100",
    blue: "hover:bg-blue-100",
    green: "hover:bg-green-100",
    purple: "hover:bg-purple-100",
  };

  const textHoverClasses = {
    red: "hover:text-red-500",
    orange: "hover:text-orange-500",
    blue: "hover:text-blue-500",
    green: "hover:text-green-500",
    purple: "hover:text-purple-500",
  };

  return (
    <section ref={ref} className="bg-gray-100 ">
      <div className="container mx-auto px-6 md:px-12 text-center relative">
        <h2 className="text-4xl font-bold text-orange mb-4">Achievements</h2>
        <hr
          className="w-1/6 mx-auto mb-10"
          style={{
            border: "none",
            borderTop: "2px dashed",
            borderImage: "linear-gradient(to right, #ffcccc, #fa5d15) 1",
            height: "0",
          }}
        />

        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-10">
          {achievements.map(({ id, icon: Icon, count, label, tooltip, color }) => (
            <div
              key={id}
              className={`flex flex-col items-center transition transform cursor-pointer rounded-lg p-6 shadow-lg relative ${bgHoverClasses[color]}`}
              onMouseEnter={() => setHoveredId(id)}
              onMouseLeave={() => setHoveredId(null)}
            >
              <Icon
                className={`text-${color}-500 transition-transform transform ${textHoverClasses[color]}`}
                style={{ fontSize: 30 }}
              />
              <h3
                className={`text-4xl font-bold text-gray-800 mt-4 ${textHoverClasses[color]}`}
              >
                {inView && <CountUp end={count} duration={3} separator="," />}+
              </h3>
              <p className={`text-gray-600 mt-2 ${textHoverClasses[color]}`}>
                {label}
              </p>

              {/* Tooltip */}
              {hoveredId === id && (
                <div
                  className="absolute bottom-full mb-3 left-1/2 -translate-x-1/2 w-56 bg-orange-400 text-white text-sm rounded-md p-3 shadow-lg pointer-events-none select-none opacity-90 text-center"
                  style={{ whiteSpace: "normal", zIndex: 50 }}
                >
                  {tooltip}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
